import { CancelledError } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { getOrderListQueryOptions } from '#pages/staff/take-order'
import { getCitySlugByName } from '#entities/city'
import { getServiceTemplateQueryOptions } from '#entities/order'
import { staffMeQueryOptions } from '#entities/staff'

export const Route = createFileRoute('/staff/_post-registration-required/_confirmation-required/take-order')({
  loader: async ({ context }) => {
    const { queryClient } = context

    const staff = await queryClient.fetchQuery(staffMeQueryOptions)

    return Promise.all([
      queryClient.ensureQueryData(getServiceTemplateQueryOptions(getCitySlugByName(staff?.city))).catch(error => {
        if (error instanceof CancelledError) return
        return Promise.reject(error)
      }),
      queryClient.fetchInfiniteQuery(getOrderListQueryOptions('', [])).catch(error => {
        if (error instanceof CancelledError) return
        return Promise.reject(error)
      }),
    ])
  },
})
